import clsx from 'clsx'
import React from 'react'

interface LaurelsTitleProps {
  largePX?: boolean
  secondary?: boolean
}

const LaurelsTitle = (props: LaurelsTitleProps) => {
  const isDark = props?.secondary ? '' : '-dark'

  return (
    <div
      className={clsx('flex flex-row items-center', {
        'px-[36.938px]': props?.largePX,
        'px-[36.5px]': !props.largePX,
      })}
    >
      <svg className="w-[33px] h-16">
        <use href={`/svg/sprite.svg#left-leaf${isDark}`}></use>
      </svg>
      <div className="relative flex flex-col gap-2 grow justify-center items-center text-center">
        <h2
          className={clsx('uppercase pb-0.5', {
            'text-logo font-semibold tracking-[0.5px] text-darkGrayText': props?.secondary,
            'opacity-50 tracking-[1.5px] text-M font-bold': !props?.secondary,
          })}
        >
          Cleaned over
        </h2>
        <p className="text-XL font-bold pb-0.5">50+ Million Photos</p>
      </div>
      <svg className="w-[33px] h-16">
        <use href={`/svg/sprite.svg#right-leaf${isDark}`}></use>
      </svg>
    </div>
  )
}

export default LaurelsTitle
